import { type DocumentSignature, signatureLine } from '../../../utils/signature'

type Props = {
  signature?: DocumentSignature | null
  className?: string
  /** The fixed label of the page's language in place of "Signed by:" (translated patient documents). */
  label?: string
}

/** The signature at the bottom of a signed document; nothing for an unsigned one (drafts). */
const SignatureBlock = ({ signature, className = '', label }: Props) => {
  const line = signatureLine(signature, label)
  if (!line) return null
  return (
    <p
      className={`signature-block mt-4 border-t border-[#DDD] pt-2 text-sm font-medium text-[#333] ${className}`.trim()}
      data-testid="signature-block"
    >
      {line}
    </p>
  )
}

export default SignatureBlock
